import { render, staticRenderFns } from "./AutoCollect.vue?vue&type=template&id=27890989&scoped=true"
import script from "./AutoCollect.vue?vue&type=script&lang=js"
export * from "./AutoCollect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27890989",
  null
  
)

export default component.exports